import { useState } from "react";
import { showSuccess, showError } from "utils/notifications";

const useFormSubmit = (apiCall, validateForm, onSuccess, FormSuccessMessage, ...options) => {
  const [loading, setLoading] = useState(false);
  const [refatch, setRefatch] = useState(false);
  const [response, setResponse] = useState(null);
  const handleSubmit = async (e, values) => {
    if (e?.preventDefault) e.preventDefault();
    // Validate form
    const validationErrors = validateForm(values);
    if (Object.keys(validationErrors).length > 0) return validationErrors

    try {
      setLoading(true);
      const response = await apiCall(values);
      if (response?.data?.success) {
        showSuccess(response.data.data.message || FormSuccessMessage);
        setRefatch(!refatch);
        if (onSuccess) {
          onSuccess(response.data);
          setResponse(response.data.data);
        }
        else {
          return null
        }
      } else {
        if ((response?.data?.status === 400 || response?.status === 400) && Array.isArray(response.data.error)) {
          response.data.error.forEach((err) => showError(err));
        } else {
          showError(response?.data?.error || "Something went wrong!");
        }
      }
    } catch (err) {
      console.error("Form submit error:", err);
      showError("Unexpected error, please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return { loading, handleSubmit, refatch, response };
};

export default useFormSubmit;
